export const inp = "w-full mt-1 rounded-lg px-3 h-12 text-base";
export const btn = "inline-flex items-center justify-center gap-2 font-bold rounded-full px-5 py-2.5 transition-[background-color,transform] active:scale-95 disabled:opacity-50";
export const btnRed = `${btn} bg-[#B23A38] hover:bg-[#962F2D] text-white`;
export const btnBlue = `${btn} bg-[#3D88B8] hover:bg-[#2F6F98] text-white`;
export const btnGhost = `${btn} border-2 border-slate-300 hover:border-[#3D88B8] text-[#0B1D3A] bg-white`;
export const card = "bg-white rounded-2xl border border-slate-200 p-5";

const DAYS = ["dom", "lun", "mar", "mié", "jue", "vie", "sáb"];
export const dayLabel = (iso) => {
  const d = new Date(`${iso}T12:00:00`);
  return `${DAYS[d.getDay()]} ${d.getDate()}/${d.getMonth() + 1}`;
};
export const iso = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;

export const Field = ({ label, children }) => (
  <label className="block text-sm font-bold text-[#0B1D3A]">{label}{children}</label>
);

export const Tag = ({ children, tone = "blue" }) => {
  const c = { blue: "bg-[#EAF3F9] text-[#2F6F98]", red: "bg-red-50 text-[#B23A38]", gray: "bg-slate-100 text-slate-600", green: "bg-emerald-50 text-emerald-700" }[tone];
  return <span className={`inline-block text-xs font-bold uppercase tracking-wide px-2 py-0.5 rounded ${c}`}>{children}</span>;
};

export const ROLE = { admin: "Administrador", instructor: "Instructor", member: "Alumno", public: "Seguidor" };
